import { ErrorPageDetailsTypes } from '@/types/errorPageDetailsTypes';

export const errorPageDetailsConstant: ErrorPageDetailsTypes = {
  description:
    'Oops! Qualcosa è andato storto. Si prega di riprovare tra un po.',
  title: 'Errore di sistema',
};
